import React from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { AssessmentProgress } from "@/components/manager/AssessmentProgress"
import { AssignTab } from "@/components/manager/AssignTab"
import { SettingsTab } from "@/components/manager/SettingsTab"

export function AssignmentsPage() {
  const [tab, setTab] = React.useState("progress")

  return (
    <div className="space-y-6 overflow-auto p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Assignments</h1>
        <p className="text-sm text-muted-foreground">
          Assign competency assessments and track progress
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="progress">Progress</TabsTrigger>
          <TabsTrigger value="assign">Assign</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="progress" className="mt-4">
          <AssessmentProgress />
        </TabsContent>
        <TabsContent
          value="assign"
          forceMount
          className="mt-4 data-[state=inactive]:hidden"
        >
          <AssignTab onAssigned={() => setTab("progress")} />
        </TabsContent>
        <TabsContent
          value="settings"
          forceMount
          className="mt-4 data-[state=inactive]:hidden"
        >
          <SettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
